export const GET_BROKERS = 'GET_BROKERS';
export const BROKER_REQUEST = 'BROKER_REQUEST';
export const CREATE_BROKER = 'CREATE_BROKER';
export const UPDATE_BROKER = 'UPDATE_BROKER';
export const DELETE_BROKER = 'DELETE_BROKER';
export const BROKER_REQUEST_FAILURE = 'BROKER_REQUEST_FAILURE';
export const GET_BROKERS_PAGE = 'GET_BROKERS_PAGE';
export const BROKER_REQUEST_SUCCESS = 'BROKER_REQUEST_SUCCESS';